/*
 * Referral Lite — storefront referral tracker
 * Manual theme install only. Attribution-only. No PII, no analytics.
 */
(function () {
  "use strict";

  var CODE_KEY = "referral_lite_code";
  var TS_KEY = "referral_lite_timestamp";
  var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
  var CODE_RE = /^[A-Za-z0-9_-]{1,64}$/;

  function safe(fn) {
    try {
      return fn();
    } catch (e) {
      return undefined;
    }
  }

  function getRefParam() {
    return safe(function () {
      return new URLSearchParams(window.location.search).get("ref");
    });
  }

  function readStored() {
    return (
      safe(function () {
        var code = window.localStorage.getItem(CODE_KEY);
        var ts = window.localStorage.getItem(TS_KEY);
        if (!code || !ts) return null;
        var n = parseInt(ts, 10);
        if (!n || isNaN(n)) return null;
        return { code: code, ts: n };
      }) || null
    );
  }

  function store(code, ts) {
    safe(function () {
      window.localStorage.setItem(CODE_KEY, code);
      window.localStorage.setItem(TS_KEY, String(ts));
    });
  }

  function clearStored() {
    safe(function () {
      window.localStorage.removeItem(CODE_KEY);
      window.localStorage.removeItem(TS_KEY);
    });
  }

  function cartRoot() {
    return (
      safe(function () {
        if (
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
        ) {
          return window.Shopify.routes.root;
        }
        return "/";
      }) || "/"
    );
  }

  function updateCartAttributes(refValue, tsValue) {
    safe(function () {
      var url = cartRoot() + "cart/update.js";

      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            __affiliate_ref: refValue,
            __affiliate_ref_timestamp: tsValue
          }
        })
      }).catch(function () {});
    });
  }

  function run() {
    var incoming = getRefParam();

    if (incoming && CODE_RE.test(incoming)) {
      store(incoming, Date.now());
    }

    var stored = readStored();

    if (!stored) return;

    var age = Date.now() - stored.ts;

    if (
      age < 0 ||
      age > THIRTY_DAYS_MS ||
      !CODE_RE.test(stored.code)
    ) {
      clearStored();
      updateCartAttributes("", "");
      return;
    }

    updateCartAttributes(stored.code, String(stored.ts));
  }

  safe(function () {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", run);
    } else {
      run();
    }
  });
})();